export default __webpack_public_path__ + "static/media/cont_item_20.e1ffd33c.svg";